import { observer } from 'mobx-react-lite';
import React, { useEffect, useRef } from 'react';
import { Container } from '@mui/material';
import { useStore } from 'src/stores';
import InformationBanner from 'src/components/shared/InformationBanner';
import { MfaReminderBanner } from 'src/components/shared/MfaReminderBanner';
import useStyles from './styles';

// NotificationType enum order on the backend: Info, Warning, Error, Success
const SEVERITY_BY_INDEX = ['info', 'warning', 'error', 'success'];
const ALLOWED_SEVERITIES = ['info', 'warning', 'error', 'success'];
const getSeverity = notificationType => {
  if (typeof notificationType === 'number') {
    var _SEVERITY_BY_INDEX$no;
    return (_SEVERITY_BY_INDEX$no = SEVERITY_BY_INDEX[notificationType]) !== null && _SEVERITY_BY_INDEX$no !== void 0 ? _SEVERITY_BY_INDEX$no : 'info';
  }
  const severity = String(notificationType !== null && notificationType !== void 0 ? notificationType : '').toLocaleLowerCase();
  return ALLOWED_SEVERITIES.includes(severity) ? severity : 'info';
};
export const PendingBanners = observer(() => {
  const store = useStore();
  const classes = useStyles();
  const banners = store.notifications.pendingBanners;
  const viewedIdsRef = useRef(new Set());
  const bannerIds = banners.map(item => item.id).join(',');
  useEffect(() => {
    banners.forEach(item => {
      if (viewedIdsRef.current.has(item.id)) return;
      viewedIdsRef.current.add(item.id);
      store.notifications.viewNotificationAsync.run({
        notificationId: item.id
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bannerIds]);
  const handleCross = async id => {
    store.notifications.removePendingBanner(id);
    await store.notifications.acknowledgementNotificationAsync.run({
      notificationId: id
    });
  };
  return (
    /*#__PURE__*/
    // Collapses through :empty when neither the MFA reminder nor any server banner renders.
    React.createElement(Container, {
      className: classes.bannersWrapper
    }, /*#__PURE__*/React.createElement(MfaReminderBanner, null), banners.map(item => /*#__PURE__*/React.createElement(InformationBanner, {
      key: item.id,
      type: getSeverity(item.notificationType),
      title: item.title,
      text: item.body,
      btnLink: item.showButton ? item.buttonUrl : null,
      btnTitle: item.showButton ? item.buttonTitle : null,
      handleCross: () => handleCross(item.id)
    })))
  );
});